import React, { useState } from 'react';
import { MoreVertical, Trash2, AlertTriangle } from 'lucide-react';
import { Asset } from '../types/assets';
import { assetsApi } from '../services/assetsApi';

interface AssetMenuProps {
  asset: Asset;
  onDelete: () => void;
}

const AssetMenu: React.FC<AssetMenuProps> = ({ asset, onDelete }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    try {
      setDeleting(true);
      await assetsApi.deleteAsset(asset.assetId);
      onDelete();
    } catch (error) {
      console.error('Error deleting asset:', error);
    }
  };

  return (
    <div className="relative">
      <button 
        onClick={() => setShowMenu(!showMenu)}
        className="text-gray-400 hover:text-gray-500"
      >
        <MoreVertical className="w-5 h-5" />
      </button>

      {showMenu && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-50">
          <button
            onClick={() => {
              setShowMenu(false);
              setShowDeleteConfirm(true);
            }}
            className="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50"
          >
            <Trash2 className="w-4 h-4 mr-2" />
            Delete Asset
          </button>
        </div>
      )}

      {showDeleteConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <div className="flex items-center mb-4">
              <AlertTriangle className="w-6 h-6 text-red-600 mr-2" />
              <h3 className="text-lg font-medium">Delete Asset</h3>
            </div>
            
            <p className="text-gray-600 mb-4">
              Are you sure you want to delete "{asset.fileName}"? This action cannot be undone.
            </p>

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowDeleteConfirm(false)}
                className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
                disabled={deleting}
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  handleDelete();
                }}
                disabled={deleting}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-50"
              >
                {deleting ? 'Deleting...' : 'Delete'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AssetMenu;